import React, { useState } from 'react';

const ExpandableText = ({ title, description, items, limit = 50 }) => {
  const [expanded, setExpanded] = useState(false);

  // Combine description and items to calculate total content length
  const itemsText = items?.join(' ') || '';
  const totalText = (description || '') + ' ' + itemsText;
  const isLong = totalText.length > limit;

  const shouldShowFull = expanded || !isLong;

  return (
    <div>
      <h4 className="text-lg font-semibold mb-2">{title}</h4>

      {/* Description */}
      {description && (
        <p className="text-sm mb-2">
          {shouldShowFull ? description : `${description.slice(0, limit)}...`}
        </p>
      )}

      {/* Items */}
      {items && items.length > 0 && shouldShowFull && (
        <ul className="list-disc pl-6">
          {items.map((item, index) => (
            <li key={index} className="text-sm">{item}</li>
          ))}
        </ul>
      )}

      {isLong && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-2 text-blue-600 hover:underline text-sm"
          style={{
            borderRadius: '20px',
            cursor: 'pointer',
            height: '35px',
            width: 'auto',
            lineHeight: '16px',
          }}
        >
          {expanded ? 'Read Less' : 'Read More'}
        </button>
      )}
    </div>
  );
};

export default ExpandableText;
